/**
 * خيارات إنشاء مفتاح Redis موحد ومرن
 */
export type KeyOptions = {
    prefix: string;               // الكيان الرئيسي (مثل: product, category)
    id?: string | number;         // المعرف الفريد للكيان
    namespace?: string;           // مساحة اسم إضافية (مثل: user, lang, vendor)
    parts?: (string | number)[];  // أجزاء إضافية للمفتاح (مثل: ["filter", "active"])
  };
  
  /**
   * ينشئ مفتاح Redis بتنسيق مرن وثابت
   * @param options - كائن يحتوي على خيارات بناء المفتاح
   * @returns مفتاح Redis النهائي على هيئة string
   */
  export const getKey = ({
    prefix,
    id,
    namespace,
    parts = [],
  }: KeyOptions): string => {
    const segments: (string | number)[] = [prefix];
  
    if (namespace) segments.push(namespace);
    if (id !== undefined) segments.push(id);
    if (parts.length) segments.push(...parts);
  
    return segments.join(":");
  };